import { render, staticRenderFns } from "./veHqUser.vue?vue&type=template&id=ffbd4c50&scoped=true"
import script from "./veHqUser.vue?vue&type=script&lang=js"
export * from "./veHqUser.vue?vue&type=script&lang=js"
import style0 from "./veHqUser.vue?vue&type=style&index=0&id=ffbd4c50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbd4c50",
  null
  
)

export default component.exports